import './modalInformation.css';
import ButtonTemplate from '../buttonTemplate/ButtonTemplate';
import ReactFocusLock from 'react-focus-lock';
import { useStoreContext } from '../../hooks/context/StoreContext';
import { ReactComponent as IconeSucesso } from '../../assets/icones/checkcircle.svg';
import { ReactComponent as IconeAtencao } from '../../assets/icones/warning.svg';

const ModalInformation = ({
    isOpen,
    closeModal,
    icone,
    titulo,
    texto
}) => {

    const { setModal } = useStoreContext();

    const fechar = () => {
        if (closeModal) {
            closeModal();
        } else {
            setModal(prevModal => ({
                ...prevModal,
                openModalInformacao: false
            }));
        }
    };

    const handleFecharModal = (e) => {
        if (e.key === 'Escape') {
            fechar();
        };
    };

    if (!isOpen) return null;

    const ehHtml = typeof texto === 'string' && (
        texto.includes('<div') || 
        texto.includes('<span') || 
        texto.includes('<p') || 
        texto.includes('<br') || 
        texto.trim().startsWith('<')
    );

    return (
        <div className='container information' onKeyDown={handleFecharModal}>
            <ReactFocusLock>
                <div className='modal information'>
                    <div className='modal-header information'>
                        {icone === 'warning' ?
                            <IconeAtencao 
                                height={'48px'}
                                width={'48px'}
                                fill={'#FFFFFF'}
                            />
                            :
                            <IconeSucesso 
                                height={'48px'}
                                width={'48px'}
                                fill={'#FFFFFF'}
                            />
                        }
                    </div>
                    <div className='modal-body information'>
                        <div className='container-information'>
                            {titulo && <h4>{titulo}</h4>}
                            {ehHtml ? (
                                <div className='texto-informacao-modal' dangerouslySetInnerHTML={{ __html: texto }} />
                            ) : (
                                <p dangerouslySetInnerHTML={{ __html: texto }} />
                            )}
                        </div>
                    </div>
                    <div className='modal-footer information'>
                        <ButtonTemplate click={fechar} background={'#212121'}>
                            Fechar
                        </ButtonTemplate>
                    </div>
                </div>
            </ReactFocusLock>
        </div>
    );
};

export default ModalInformation;
